import Product from '../models/product.model'

let storeContent = utils.generateStore({
   Product,
   products: [
      {
         logo: '/img/uap.png',
         product_name: 'Bima Bora',
         product_code: 'health_bima_001',
         class: [{
            class_code: 'motor',
            sub_class_code: 'motor_sub_class',
         }],
         status: 'Active',
      },
      {
         logo: '/img/uap.png',
         product_name: 'Bima Bora',
         product_code: 'health_bima_001',
         class: [{
            class_code: 'health',
            sub_class_code: 'bima_sub_class',
         }],
         status: 'Active',
      },
      {
         logo: '/img/uap.png',
         product_name: 'Bima Bora',
         product_code: 'health_bima_001',
         class: [{
            class_code: 'health',
            sub_class_code: 'bima_sub_class',
         }],
         status: 'Active',
      },
   ],
   table_data: [],
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      submitForm(ctx,ref) {
         ctx.commit('loading', true)
         
         setTimeout(() => {
            ctx.commit('table_data',ctx.getters.products)
            ctx.commit('loading',false)
         }, 5000);
      },
      async saveData(ctx,payload) {
         let data = payload.ref.form_data_
         
         if (await payload.ref.isValid()) {
            console.log(data)
            await payload.ref.resetForms()
            console.log(data)
         }
      },
   }
};